import { render } from "./HomeBroadcast.vue?vue&type=template&id=4adb5b34"
import script from "./HomeBroadcast.vue?vue&type=script&lang=js"
export * from "./HomeBroadcast.vue?vue&type=script&lang=js"
script.render = render

export default script